import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Dropdown, Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from '../../ApiCheck/Loader';
import { baseUrl } from "../../ApiCheck/Constant";
import { useSelector } from "react-redux";

function UserTable() {
  
  const user = useSelector((state) => state.user);

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [role, setRole] = useState("");
  const [profilepic, setProfilepic] = useState(null); 

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/api/alluser`);
      setUsers(response.data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error(error?.response?.data?.message || 'Failed to fetch users. Please try again.', { position: 'top-center', autoClose: 3000 });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(user.user.role === 'ADMIN') {
      fetchUsers();
    }
  }, []);

  const handleUpdate = (user) => {
    setSelectedUser(user);
    setFirstname(user.firstname);
    setLastname(user.lastname);
    setEmail(user.email);
    setPhonenumber(user.phonenumber);
    setRole(user.role); 
    setProfilepic(user.profilepic);
    setShowModal(true);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setProfilepic(reader.result);
    };
    reader.readAsDataURL(file);
    setError('');
  };

  const handleSaveChanges = async () => {
    const payload = {
      selectedUser,
      firstname,
      lastname,
      email,
      phonenumber,
      role,
      profilepic
    };
    try {
      const response = await axios.put(`${baseUrl}/api/update/${selectedUser._id}`, payload);
      toast.success("User updated successfully!", { position: 'top-center', autoClose: 3000 });
      setShowModal(false);
      fetchUsers();
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error(error.response?.data?.message, { position: 'top-center', autoClose: 3000 });
    }
  }

  const handleDelete = async (userId) => {
    try {
      await axios.delete(`${baseUrl}/api/delete/${userId}`);
      fetchUsers(); 
      toast.success("User deleted successfully!", { position: 'top-center', autoClose: 3000 });
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error(error.response?.data?.message, { position: 'top-center', autoClose: 3000 });
    }
  };

  return (
    <>
      <h3>All Users</h3>
      {isLoading ? (
        <Loader /> 
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>FirstName</th>
                <th>LastName</th>
                <th>Email</th>
                <th>PhoneNumber</th>
                <th>Role</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user) => (
                  <tr key={user._id}>
                    <td>{user.firstname}</td>
                    <td>{user.lastname}</td>
                    <td>{user.email}</td>
                    <td>{user.phonenumber}</td>
                    <td>{user.role}</td>
                    <td>
                      <img
                        src={user.profilepic}
                        className="rounded"
                        width={"100px"}
                        alt="User Profile"
                      />
                    </td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                          ⋮
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => handleUpdate(user)}>Update</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(user._id)}>
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No users found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update User</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <Form.Group controlId="firstname">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="lastname">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="phonenumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                value={phonenumber}
                onChange={(e) => setPhonenumber(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="role">
              <Form.Label>Role</Form.Label>
              <Form.Control
                as="select"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </Form.Control>
            </Form.Group>
           
            <img
              src={profilepic}
              className="rounded mt-4"
              width={"100px"}
              alt="User Profile"
            />
            
            <Form.Group controlId="imageFile">
              <Form.Label>Upload New Profile Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UserTable;
